// extracted by mini-css-extract-plugin
export default {"roomContainer":"property_unit_roomContainer__5pjtA","ratesList":"property_unit_ratesList__k8tEx"};